(() => {
  // Resolve on every click: EasySell can mount or replace its button asynchronously.
  const infoSelector = '#MainContent product-info[id^="MainProduct-"] [id^="ProductInfo-"]';
  let pending = false;

  function orderArea() {
    return document.querySelector(infoSelector);
  }

  function purchaseButton() {
    const info = orderArea();
    if (!info) return null;
    const candidates = info.querySelectorAll('#es-popup-button, .es-popup-button-product');
    return Array.from(candidates).find((button) =>
      !button.matches('[disabled], [aria-disabled="true"]') &&
      button.getClientRects().length > 0 &&
      getComputedStyle(button).visibility !== 'hidden'
    ) || null;
  }

  document.addEventListener('click', (event) => {
    const cta = event.target.closest('[data-plasturi-purchase]');
    if (!cta) return;
    event.preventDefault();
    if (pending) return;

    const button = purchaseButton();
    if (button) {
      button.click();
      return;
    }

    // Keep the existing form accessible even when the app is embedded or unavailable.
    const info = orderArea();
    const area = info && (info.querySelector('#formular') || info);
    if (area) area.scrollIntoView({ behavior: 'smooth', block: 'center' });

    // Allow a just-loading app to finish, with only one pending activation.
    pending = true;
    const deadline = Date.now() + 4000;
    const timer = window.setInterval(() => {
      const ready = purchaseButton();
      if (!ready && Date.now() < deadline) return;
      window.clearInterval(timer);
      pending = false;
      if (ready) ready.click();
    }, 100);
  });
})();
